export { JivositeEntity } from './jivosite-entity';
